import Component from '../abstracts/Component';
import hoverintent from 'hoverintent';

export default class MenuComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-menu]',
      mainTarget: 'body',
      headerTop: '.header-top',
      header: '.main-header',
      benefitBar: '.js-benefit-bar',
      menuTitle: '[data-menu-title]',
      navigation: '.navigation',
      back: '[data-menu-back]',
      actions: '.header-actions',
      search: '.search-wrapper',
      mobileActions: '.js-mobile-actions',
      subMenu: '.js-submenu',
      menuHeading: 'menu-heading'
    };
  }

  get CLASSES() {
    return {
      menuIn: 'menu-in',
      openClass: 'is-open',
      animate: 'animate',
      activeClass: 'is-active',
      subMenuClass: 'sub-menu-container',
      menuHeadingVisible: 'menu-heading-visible',
      logoHidden: 'logo-hidden',
      searchIsVisible: 'search-visible',
      visible: 'is-visible',
      showBackdrop: 'show-backdrop',
      fixed: 'is-fixed'
    };
  }

  get DIMENSION() {
    return {
      top: () => {
        let header = document.querySelector(this.SELECTORS.header);
        let search = document.querySelector(this.SELECTORS.search);
        let sticky = header.classList.contains('is_stuck');
        return sticky ? header.clientHeight - search.clientHeight + 1 : header.clientHeight - search.clientHeight + this.DIMENSION.benefitBar() + 1;
      },
      benefitBar: () => {
        let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
        return this.$matchMedia(null, 'sm') ? benefitBar.clientHeight : 0;
      }
    }
  }

  constructor() {
    super();
    this.backDropTimeout = null;
    this.preventClose = false;
    this.timeoutBackdrop = null;
  }

  closeNav() {

    return new Promise((resolve, reject) => {
      try {
        this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        const navigation = document.querySelector(this.SELECTORS.navigation);
        navigation.classList.remove(this.CLASSES.showBackdrop);
      } catch (e) {
        reject(e)
      }
    });

  }
  openNav() {
    return new Promise((resolve, reject) => {
      try {
        const navigation = document.querySelector(this.SELECTORS.navigation);
        if (this.$matchMedia(null, 'sm')) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark'});
        }
        navigation.classList.add(this.CLASSES.showBackdrop)
      } catch (e) {
        reject(e)
      }
    });
  }

  open(el, showChildren) {
    return new Promise((resolve, reject) => {
      try {
        const navigation = document.querySelector(this.SELECTORS.navigation);
        let bgColor = el.dataset.bgColor;

        if (!el.classList.contains('has-sub-navigation')) {
          navigation.classList.remove(this.CLASSES.showBackdrop);
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
          //return;
        } else {
          if (bgColor) {
            navigation.style.setProperty('--bg-color', bgColor);
          }
          this.openNav();
        }

        const subMenuContainer = el.querySelector(`.${this.CLASSES.subMenuClass}`);
        el.classList.add(this.CLASSES.activeClass);
        //this.openNav();
        if (this.$matchMedia(null, 'sm')) {
          //this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark'});
        }

        if (showChildren && subMenuContainer) {
          clearTimeout(this.timeoutBackdrop);
          subMenuContainer.classList.add(this.CLASSES.animate);
          subMenuContainer.classList.add(this.CLASSES.openClass);
          navigation.classList.add('timeout');
          //navigation.classList.add(this.CLASSES.showBackdrop)
        }
        resolve(el)
      } catch (e) {
        reject(e)
      }
    });
  }

  close(el, showChildren) {
    return new Promise((resolve, reject) => {
      try {
        if (this.preventClose) return;
        const subMenuContainer = el.querySelector(`.${this.CLASSES.subMenuClass}`);
        const navigation = document.querySelector(this.SELECTORS.navigation);
        el.classList.remove(this.CLASSES.activeClass);
        if (subMenuContainer) {
          subMenuContainer.classList.remove(this.CLASSES.activeClass);
          if (showChildren) {
            subMenuContainer.classList.remove(this.CLASSES.openClass);
            subMenuContainer.classList.remove(this.CLASSES.animate);
            this.timeoutBackdrop = setTimeout(() => {
              navigation.classList.remove('timeout')
            }, 300);
          }
        }
        navigation.style.removeProperty('--bg-color');
        // this.backDropTimeout = setTimeout(() => {
        //   this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        //   const navigation = document.querySelector(this.SELECTORS.navigation);
        //   navigation.classList.remove(this.CLASSES.showBackdrop);
        // }, 250);
        resolve(el)
      } catch (e) {
        reject(e)
      }
    });
  }

  setHeadingValue(str, link) {
    let headerTop = document.querySelector(this.SELECTORS.headerTop);
    headerTop.querySelector(this.SELECTORS.menuTitle).innerText = str.trim();
    headerTop.querySelector(this.SELECTORS.menuTitle).setAttribute('href', link);
    headerTop.classList.add(this.CLASSES.menuHeadingVisible);
  }

  forceClose(hideBackdrop) {
    return new Promise((resolve, reject) => {
      try {

        const subMenuContainer = document.querySelectorAll(`.${this.CLASSES.subMenuClass}`);
        if (subMenuContainer)
          subMenuContainer.forEach(el => {
            el.classList.remove(this.CLASSES.activeClass, this.CLASSES.openClass, this.CLASSES.animate)
          });
        if (hideBackdrop) {
          const navigation = document.querySelector(this.SELECTORS.navigation);
          navigation.classList.remove(this.CLASSES.showBackdrop);
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        }
        resolve();
      } catch (e) {
        reject()
      }
    });
  }


  bindHover() {

    let main = document.querySelectorAll(this.SELECTORS.main);
    let nav = document.querySelector(this.SELECTORS.navigation)

    //display menu container
    hoverintent(nav, (e) => {
      if (e.target.parentElement.classList.contains('has-sub-navigation')) {
        this.openNav();
      }
    }, (e) => {
      this.closeNav();
    }).options({
      timeout: 100
    });

    //show submenus
    main.forEach(el => {
      hoverintent(el, (e) => {
        if (this.$matchMedia(null, 'lg') && e.target.parentElement.hasAttribute('data-menu')) {
          clearTimeout(this.backDropTimeout);
          this.forceClose().then(res => {
            this.open(e.target.parentElement, true).then(res => this.preventClose = false);
          });
        }
      }, (e) => {
        if (this.$matchMedia(null, 'lg')) {
          clearTimeout(this.backDropTimeout);
          this.forceClose().then(res => {
            this.close(e.target.parentElement, true);
          });
        }
      }).options({
        timeout: 50,
        interval: 50
      });
    });

    this.$on('mouseenter.subMenu', () => {
      clearTimeout(this.backDropTimeout);
      this.preventClose = true;
    }, this.SELECTORS.subMenu);

    this.$on('mouseleave.subMenu', () => {
      this.preventClose = false;
    }, this.SELECTORS.subMenu);

  }

  bindEscape() {
    this.$on(`${this.$customEvents.KEYBOARD_EVENTS.escape}.menu`, () => {
      this.forceClose(true).then(res => {
        this.focusTrigger.nextSibling.focus();
      });
    });
  }

  showSearch() {
    let header = document.querySelector(this.SELECTORS.header);

    this.$on(this.$customEvents.SEARCH_EVENTS.visible, () => {
      header.classList.add(this.CLASSES.searchIsVisible);
    });

    this.$on(this.$customEvents.SEARCH_EVENTS.hidden, () => {
      header.classList.remove(this.CLASSES.searchIsVisible)
    });
  }

  bindClick() {

    this.$on('click.menu', ({event}) => {
      if (!event.target.classList.contains('js-first-level-link')) return true;
      if (!this.$matchMedia('lg')) return true;
      const menuHeading = document.getElementsByClassName(this.SELECTORS.menuHeading);
      if(menuHeading != null && menuHeading[0] != null) {
        menuHeading[0].style.display = "";
      }
      event.preventDefault();
      [...event.currentTarget.parentElement.children].map(sibling => {
        return sibling.classList.remove(this.CLASSES.activeClass)
      });
      event.currentTarget.classList.toggle(this.CLASSES.activeClass);

      let link = event.currentTarget.querySelector('a.link');
      this.setHeadingValue(link.innerText, link.getAttribute('data-category-link'))

    }, `${this.SELECTORS.main}.has-sub-navigation`);

    this.$on(this.$customEvents.QUICK_CATEGORIES_EVENTS.show, ({payload}) => {
      this.timeout = null;
      this.quickCategoryShow(payload.id).then(el => {
        clearTimeout(this.timeout);
        this.$emit(this.$customEvents.QUICK_CATEGORIES_EVENTS.visible);
        this.timeout = setTimeout(() => {
          let link = el.querySelector('a.link');
          this.setHeadingValue(link.innerText, link.getAttribute('data-category-link'));
        }, 300);
      });
    });

  }

  quickCategoryShow(id) {
    return new Promise((resolve, reject) => {
      try {
        const target = document.querySelector(`#${id}`);
        target.classList.add(this.CLASSES.activeClass);
        resolve(target);
      } catch (e) {
        reject(e)
      }
    });
  }

  bindBack() {
    this.$on('click.menu', () => {
      if (!this.$matchMedia('sm')) return true;
      let menuTriggers = document.querySelectorAll(this.SELECTORS.main);
      document.querySelector(this.SELECTORS.headerTop).classList.remove(this.CLASSES.menuHeadingVisible);
      menuTriggers.forEach(trigger => {
        return trigger.classList.remove(this.CLASSES.activeClass)
      });
    }, this.SELECTORS.back)
  }

  toggleMobileActions(show) {
    const actions = document.querySelector(this.SELECTORS.mobileActions);
    let timeout = null;
    let header = document.querySelector(this.SELECTORS.header);
    if (show) {
      timeout = setTimeout(() => {
        header.classList.add(this.CLASSES.fixed);
        actions.classList.add(this.CLASSES.visible)
      }, 200);
    } else {
      clearTimeout(timeout);
      header.classList.remove(this.CLASSES.fixed);
      actions.classList.remove(this.CLASSES.visible)
    }
  }

  bindBurgerClick() {
    this.$on(this.$customEvents.BURGER_EVENTS.click, ({payload}) => {
      let headerTop = document.querySelector(this.SELECTORS.headerTop);
      if (payload.menuIn) {
        document.documentElement.classList.add(this.CLASSES.menuIn);
        headerTop.classList.add(this.CLASSES.menuIn);
        if(this.hasToGoDirectlyToNavigationMenu()){
          this.navigateToCurrentNavigationMenu();
        }
        document.body.classList.add(this.CLASSES.menuIn);


        if (this.$matchMedia(null, 'sm')) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark'});
        }
      } else {
        let dataMenu = document.querySelector(`${this.SELECTORS.main}.${this.CLASSES.activeClass}`);
        if (dataMenu) dataMenu.classList.remove(this.CLASSES.activeClass);
        document.body.classList.remove(this.CLASSES.menuIn);
        document.documentElement.classList.remove(this.CLASSES.menuIn);
        headerTop.classList.remove(this.CLASSES.menuIn, this.CLASSES.menuHeadingVisible);

        // if (browser && browser.name === 'ios') nav.style.height = ''; // this is necessary to handle the bottom bar on safary mobile

        if (this.$matchMedia(null, 'sm')){
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        }
      }

      this.toggleMobileActions(payload.menuIn);

    });
  }

  bindKeyboardNavigation() {
    let timeout;

    this.$on('focus.menu', ({event}) => {
      clearTimeout(timeout);
      this.forceClose().then(res => {
        timeout = setTimeout(() => {
          this.open(event.currentTarget.parentElement, true).then(res => {
            this.focusTrigger = res;
          });
        }, 350);
      });
    }, `${this.SELECTORS.main} > a`);

    this.bindEscape();
  }

  navigateToCurrentNavigationMenu(){
    let currentMenu = this.getCurrentNavigationMenu();
    if(currentMenu){

      const sibilings=$(`${this.SELECTORS.navigation}.navigation-mobile li`);
      sibilings.removeClass(this.CLASSES.activeClass);
        let currentTarget = $(`${this.SELECTORS.navigation}.navigation-mobile li[data-menu=".js-submenu-${currentMenu}"]`);
        currentTarget.addClass(this.CLASSES.activeClass);
        let link = $('a.link',currentTarget);
        const menuHeading = document.getElementsByClassName(this.SELECTORS.menuHeading);
        if(currentTarget.hasClass('has-sub-navigation')) {
          this.setHeadingValue(link.text(), link.attr('data-category-link'));
          if(menuHeading != null && menuHeading[0] != null) {
            menuHeading[0].style.display = "";
          }
        }else {
          if(menuHeading != null && menuHeading[0] != null) {
            menuHeading[0].style.display = "none";
          }
        }
    }
  }

  getCurrentNavigationMenu() {
    //to retrieve cat link first of all try to retrieve it from breadcrumb
    let breadCrumbNavigationItem=$('a','.breadcrumb li[typeof=ListItem]:has([content="2"][property="position"])')
    let currentMenu;
    //if the breadcrumb is available gets the second element href, otherwise try to retrieve it from url
    if(breadCrumbNavigationItem && breadCrumbNavigationItem.attr("href")){
      currentMenu = breadCrumbNavigationItem.attr("href");
    }else{
      currentMenu = window.location.pathname;
    }
    //parse the uri to retrieve js-submenu-* element
    currentMenu=currentMenu.match(/^\/([\w\d\_\-]+)/);
    if (currentMenu && currentMenu[0]) {
      currentMenu = currentMenu[0].replace("/","");
    }
    return currentMenu;
  }

  hasToGoDirectlyToNavigationMenu(){
    return this.isMobile() && this.getCurrentNavigationMenu()
  }

  isMobile(){
    return window.matchMedia('(max-width:767px)');
  }

  bindMobileEvents() {

    this.bindClick();
    this.bindBack();
    this.bindBurgerClick();
  }

  render() {
    if (document.querySelector(this.SELECTORS.header) === null) return;
    this.bindMobileEvents();
    this.bindHover();
    this.showSearch();
    this.bindKeyboardNavigation();

  }
}
